import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Fragment, useEffect, useRef, useState } from "react";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";

import ImgCapture from "./ImgCapture";
import { useAxios } from "../../hooks";
import { setDisplayName } from "../../redux/slices/memberSlice";
import { LoadingButton, OuterBox, TextField } from "../../components";

const MainGateEntryWithBackCamera = () => {
  const axios = useAxios({
    baseURL: "mox_api_2",
  });

  const dispatch = useDispatch();

  const location = useLocation();

  const videoRef = useRef(null);

  const { displayName } = useSelector((state) => state.memberDetails);

  const [eventList, setEventList] = useState([]);
  const [gates, setGates] = useState([]);
  const [userStep, setUserStep] = useState("");
  const [cameraScreen, setCameraScreen] = useState("environment");
  const [loading, setLoading] = useState(false);
  const [selectedGate, setSelectedGate] = useState(
    Number(sessionStorage.getItem("gateMateNo")) || 0
  );

  const [entryStatus, setEntryStatus] = useState(false);
  const [guardDetails, setGuardDetails] = useState({
    name: displayName || "",
    gateNo: 0,
    QRCode: "",
    ImgData: "",
    eventID: "",
    entityType: "",
  });

  const [faceVerificationStatus, setFaceVerificationStatus] =
    useState(undefined);

  const [appointmentStatus, setAppointmentStatus] = useState(undefined);

  const [userDetail, setUserDetail] = useState({});

  const [entityType, setEntityType] = useState([]);

  const [userLocation, setUserLocation] = useState({
    gate_type: "tablet",
    lat: "",
    lng: "",
  });

  useEffect(() => {
    if (Boolean(displayName)) {
      setUserStep("QRcode");
    }

    axios({
      url: "entry/entry/entity-type",
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      setEntityType(response.data);
    });
  }, []);

  const StatusMessage = ({
    icon: Icon,
    iconColor,
    text,
    buttonText,
    onClick,
  }) => (
    <Grid
      container
      display="flex"
      sx={{ flexDirection: "column" }}
      alignItems="center"
      justifyContent="center"
    >
      <Icon sx={{ fontSize: "80px", color: iconColor, mb: "30px" }} />
      <audio
        autoPlay
        src="https://broadcast-contact-numbers.s3.ap-south-1.amazonaws.com/output_1719227737.921351_aws.wav"
      ></audio>
      <Typography
        variant="h1"
        component="h2"
        sx={{
          fontWeight: 700,
          fontSize: "18px",
          textAlign: "center",
          color: iconColor,
        }}
      >
        {text}
      </Typography>
      <Button
        variant="outlined"
        sx={{ mt: "30px", color: iconColor, border: `1px solid ${iconColor}` }}
        onClick={onClick}
      >
        {buttonText}
      </Button>
    </Grid>
  );

  const resetStatuses = () => {
    setFaceVerificationStatus(undefined);
    setAppointmentStatus(undefined);
  };

  useEffect(() => {
    return () => {
      const stopCamera = () => {
        if (videoRef.current && videoRef.current?.srcObject) {
          const tracks = videoRef.current.srcObject?.getTracks();
          tracks.forEach((track) => track.stop());
          videoRef.current.srcObject = null;
        }
      };

      stopCamera();
    };
  }, [location]);

  function handleGetLocation(position) {
    setUserLocation({
      gate_type: "tablet",
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
  }

  function handleError() {}

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(handleGetLocation, handleError);
  });

  function printImageFromURL(url) {
    const printWindow = window.open("", "_target");
    printWindow.document.write(`
    <html>
      <head>
        <title>Print Image</title>
        <style>
          body, html {
            margin: 0;
            padding: 0;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
          @media print {
  @page {
    margin: 0; /* removes whitespace from browser default */
  }

  body {
    margin: 0;
    padding: 0;
  }

  header, footer {
    display: none;
  }
}

        </style>
      </head>
      <body>
        <img src="${url}" onload="window.print(); window.onafterprint = window.close;" />
      </body>
    </html>
  `);
    printWindow.document.close();
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "75vh",
        width: ["100%", "100%", "100%", "800px"],
        margin: "0 auto",
        padding: "0px 17px",
        boxSizing: "border-box",
        background: "#FFFFFF",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          padding: "20px",
          borderRadius: "5px",
          minHeight: "20vh",
          background: "rgba(255, 255, 255, 0.5)",
          alignContent: "center",
          borderRadius: "15px",
          border: "1px solid blue",
          borderRadius: "7.5px",
        }}
      >
        {!entryStatus &&
          faceVerificationStatus === undefined &&
          appointmentStatus === undefined && (
            <Formik
              initialValues={guardDetails}
              onSubmit={(formData, { setSubmitting }) => {
                setSubmitting(true);

                let url =
                  selectedGate === 1
                    ? "/booking/verify-visitor"
                    : "booking/verify/dome-visitor";

                axios({
                  url: "/entry/entry",
                  method: "POST",
                  data: {
                    machine_id: formData.gateNo,
                    face_data: formData.ImgData,

                    ...userLocation,
                  },
                  customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
                  disableRedirect: true,
                }).then((response) => {
                  if (response.status) {
                    setEntryStatus(
                      response.data?.appointment_status &&
                        response.data?.face_verification
                    );
                    setUserDetail(response.data?.appointment_data);
                  } else {
                    setAppointmentStatus(false);
                    setFaceVerificationStatus(false);
                  }

                  setGuardDetails((prev) => ({
                    name: prev.name,
                    gateNo: formData.gateNo,
                    QRCode: prev.QRCode,
                    ImgData: prev.ImgData,
                    eventID: prev.eventID,
                    entityType: prev.entityType,
                  }));
                  setSubmitting(false);
                });
              }}
            >
              {(formikProps) => {
                function handleEventId(e) {
                  axios({
                    url: `entry/entry/machine-list?entity_id=${e.target.value}`,
                    disableRedirect: true,
                    disableError: true,
                    customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
                  }).then((response) => {
                    if (response.status) {
                      setGates(response.data);
                    }
                    formikProps.setFieldValue("eventID", e.target.value);
                  });
                }

                function handleEntityType(e) {
                  axios({
                    url:
                      "/entry/entry/entity-list?entity_type=" + e.target.value,
                    disableRedirect: true,
                    disableError: true,
                  }).then((response) => {
                    if (response.status) {
                      setEventList(response.data);
                    } else {
                      setEventList([]);
                    }
                    formikProps.setFieldValue("entityType", e.target.value);
                  });
                }
                return (
                  <Fragment>
                    {userStep === "" && (
                      <Grid container>
                        <Grid item xs={12}>
                          <TextField
                            select
                            siz="small"
                            name="entityType"
                            placeholder="Select Entity Type"
                            formikProps={formikProps}
                            onChange={handleEntityType}
                          >
                            {entityType.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.entity_id}>
                                  {item.name?.toUpperCase()}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} marginTop={"10px"}>
                          <TextField
                            select
                            siz="small"
                            name="eventID"
                            placeholder="Select Event Name"
                            formikProps={formikProps}
                            onChange={handleEventId}
                            disabled={!formikProps.values.entityType}
                          >
                            {eventList?.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item?.entity_id}>
                                  {item?.name?.toUpperCase()}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        </Grid>

                        <Grid item xs={12} marginTop={"10px"}>
                          <LoadingButton
                            variant="contained"
                            sx={{ height: "100%" }}
                            disabled={!formikProps.dirty || !eventList.length}
                            onClick={() => {
                              dispatch(setDisplayName(formikProps.values.name));
                              setUserStep("QRcode");
                            }}
                          >
                            Submit
                          </LoadingButton>
                        </Grid>
                      </Grid>
                    )}

                    {userStep === "QRcode" && (
                      <Grid container>
                        <Grid item container m={1}>
                          <Grid item xs={4}>
                            <Button
                              variant="contained"
                              onClick={() => {
                                setUserStep("");
                              }}
                            >
                              <ArrowBackIcon />
                            </Button>
                          </Grid>
                          <Grid item xs={4}>
                            <TextField
                              select
                              name="gateNo"
                              size="small"
                              formikProps={formikProps}
                              onChange={(e) => {
                                sessionStorage.setItem(
                                  "gateMateNo",
                                  e.target.value
                                );

                                setSelectedGate(e.target.value);

                                formikProps.setValues((prev) => {
                                  return { ...prev, gateNo: e.target.value };
                                });
                              }}
                              value={selectedGate}
                            >
                              <MenuItem value={0}>
                                Select Your Current Gate
                              </MenuItem>
                              {gates.map((item) => {
                                return (
                                  <MenuItem value={item.machine_id}>
                                    {item.zone_name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          </Grid>
                        </Grid>

                        <ImgCapture
                          loading={loading}
                          videoRef={videoRef}
                          bioFormikProps={formikProps}
                          cameraScreen={cameraScreen}
                          onSubmit={formikProps.handleSubmit}
                        />
                      </Grid>
                    )}
                  </Fragment>
                );
              }}
            </Formik>
          )}

        {entryStatus && (
          <Grid
            container
            display={"flex"}
            sx={{ flexDirection: "column" }}
            alignItems="center"
            justifyContent={"center"}
          >
            <audio
              autoPlay
              src="https://broadcast-contact-numbers.s3.ap-south-1.amazonaws.com/output_1719227404.694377_aws.wav"
            >
              {" "}
            </audio>

            <CheckCircleOutlineRoundedIcon
              sx={{
                fontSize: "70px",
                lineHeight: "21px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "rgb(41 128 31)",
                marginBottom: "30px",
              }}
            />
            <Typography
              variant="h1"
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: "25px",
                lineHeight: "21px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "rgb(41 128 31)",
              }}
            >
              Access Granted
            </Typography>
            <Typography
              variant="h1"
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: "18px",
                lineHeight: "21px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "rgb(108 108 108)",
                mt: "15px",
              }}
            >
              {`Welcome ${
                userDetail?.first_name ? userDetail?.first_name : ""
              }${userDetail?.last_name ? userDetail?.last_name : ""}!`}
            </Typography>
            <Button
              variant="outlined"
              sx={{ marginTop: "30px" }}
              onClick={() => {
                setEntryStatus(false);
                setFaceVerificationStatus(undefined);
                setAppointmentStatus(undefined);
              }}
            >
              Take Next Entry
            </Button>

            <Button
              variant="outlined"
              sx={{ marginTop: "30px" }}
              onClick={() => {
                printImageFromURL(
                  "https://verismart-digipass.s3.ap-south-1.amazonaws.com/ePass/qrCollection/cf8e12f6045847b29510be6d565e0fca.png"
                );
                // setEntryStatus(false);
                // setFaceVerificationStatus(undefined);
                // setAppointmentStatus(undefined);
              }}
            >
              Print Pass
            </Button>
          </Grid>
        )}

        {appointmentStatus !== undefined && appointmentStatus === false && (
          <StatusMessage
            icon={CancelRoundedIcon}
            iconColor="red"
            text="Visitor is not verified"
            buttonText="Try Again"
            onClick={resetStatuses}
          />
        )}

        {faceVerificationStatus !== undefined &&
          faceVerificationStatus === false &&
          appointmentStatus !== false && (
            <StatusMessage
              icon={CancelRoundedIcon}
              iconColor="red"
              text="Face Didn't Match"
              buttonText="Try Again"
              onClick={resetStatuses}
            />
          )}

        {appointmentStatus === true && faceVerificationStatus !== false && (
          <StatusMessage
            icon={CancelRoundedIcon}
            iconColor="red"
            text="Please verify at the main gate first"
            buttonText="Try Again"
            onClick={resetStatuses}
          />
        )}
      </Paper>
    </Box>
  );
};

export default MainGateEntryWithBackCamera;
